import { render, staticRenderFns } from "./LabelNew.vue?vue&type=template&id=a29a7724&"
import script from "./LabelNew.vue?vue&type=script&lang=js&"
export * from "./LabelNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports